var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.2,0.8c1,0,1.7,0.8,1.7,1.7c0,1-0.8,1.8-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7C0.5,1.5,1.3,0.8,2.2,0.8 M3.2,14.9 h-2c-0.3,0-0.5-0.2-0.5-0.5V5.7c0-0.3,0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5v8.7C3.7,14.7,3.5,14.9,3.2,14.9 M14.9,8.3 c0-1.8-1.4-3.3-3.2-3.3h-0.5c-1,0-2,0.5-2.5,1.2L8.4,6.5v-1c0-0.1-0.1-0.2-0.2-0.2H5.7c-0.1,0-0.2,0.1-0.2,0.2v9.3 c0,0.1,0.2,0.2,0.2,0.2h2.7c0.1,0,0.2-0.1,0.2-0.2V9.3c0-0.9,0.7-1.7,1.6-1.7c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.4,0.7,0.4,1.2v5.3 c0,0.1,0.1,0.2,0.2,0.2h2.5c0.1,0,0.2-0.1,0.2-0.2L14.9,8.3L14.9,8.3L14.9,8.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e35abb9b65670bfdeedae3a632076580.svg";
export { ForwardRef as ReactComponent };